export const CANCEL_INVITATION = 'users/CANCEL_INVITATION';
export const CANCEL_INVITATION_SUCCESS = 'users/CANCEL_INVITATION_SUCCESS';
export const CANCEL_INVITATION_FAILURE = 'users/CANCEL_INVITATION_FAILURE';

export const cancelInvitation = (user, currentUser) => {
    return {
        type: CANCEL_INVITATION,
        value: {
            user,
            currentUser
        }
    };
};

export const cancelInvitationSuccess = (user, currentUser) => {
    return {
        type: CANCEL_INVITATION_SUCCESS,
        value: { user, currentUser }
    };
};

export const cancelInvitationFailure = (user, error) => {
    return {
        type: CANCEL_INVITATION_FAILURE,
        value: { user, error }
    };
};

export const REMOVE_ALERT = 'users/REMOVE_ALERT';

export const removeAlert = _ => {
    return {
        type: REMOVE_ALERT
    };
};

export const REVOKE_USER = 'users/REVOKE_USER';
export const REVOKE_USER_SUCCESS = 'users/REVOKE_USER_SUCCESS';
export const REVOKE_USER_FAILURE = 'users/REVOKE_USER_FAILURE';

export const revokeUser = (user, currentUser) => {
    return {
        type: REVOKE_USER,
        value: {
            user,
            currentUser
        }
    };
};

export const revokeUserSuccess = user => {
    return {
        type: REVOKE_USER_SUCCESS,
        value: { user }
    };
};

export const revokeUserFailure = (user, error) => {
    return {
        type: REVOKE_USER_FAILURE,
        value: {
            user,
            error
        }
    };
};

export const DISABLE_USER = 'users/DISABLE';
export const DISABLE_USER_SUCCESS = 'users/DISABLE_USER_SUCCESS';
export const DISABLE_USER_FAILURE = 'users/DISABLE_USER_FAILURE';

export const disableUser = (user, currentUser) => {
    return {
        type: DISABLE_USER,
        value: {
            user,
            currentUser
        }
    };
};

export const disableUserSuccess = user => {
    return {
        type: DISABLE_USER_SUCCESS,
        value: { user }
    };
};

export const disableUserFailure = (user, error) => {
    return {
        type: DISABLE_USER_FAILURE,
        value: {
            user,
            error
        }
    };
};

export const ENABLE_USER = 'users/ENABLE';
export const ENABLE_USER_SUCCESS = 'users/ENABLE_USER_SUCCESS';
export const ENABLE_USER_FAILURE = 'users/ENABLE_USER_FAILURE';

export const enableUser = (user, currentUser) => {
    return {
        type: ENABLE_USER,
        value: {
            user,
            currentUser
        }
    };
};

export const enableUserSuccess = user => {
    return {
        type: ENABLE_USER_SUCCESS,
        value: user
    };
};

export const enableUserFailure = (user, error) => {
    return {
        type: ENABLE_USER_FAILURE,
        value: {
            user,
            error
        }
    };
};

export const FETCH_USERS = 'users/FETCH';
export const FETCH_LOCKED_USERS = 'users/FETCH_LOCKED_USERS';
export const FETCH_LOCKED_USERS_SUCCESS = 'users/FETCH_LOCKED_USERS_SUCCESS';
export const FETCH_USERS_SUCCESS = 'users/FETCH_SUCCESS';
export const FETCH_USERS_FAILURE = 'users/FETCH_FAILURE';

export const fetchUsers = currentUser => {
    return {
        type: FETCH_USERS,
        value: {
            currentUser
        }
    };
};

export const fetchLockedUsersSuccess = data => {
    return {
        type: FETCH_LOCKED_USERS_SUCCESS,
        value: data
    };
};

export const fetchLockedUsers = data => {
    return {
        type: FETCH_LOCKED_USERS,
        value: data
    };
};

export const fetchUsersSuccess = data => {
    return {
        type: FETCH_USERS_SUCCESS,
        value: data
    };
};

export const fetchUsersFailure = error => {
    return {
        type: FETCH_USERS_FAILURE,
        value: error
    };
};

export const INVITE_USER = 'users/INVITE';
export const INVITE_USER_SUCCESS = 'users/INVITE_SUCCESS';
export const INVITE_USER_FAILURE = 'users/INVITE_FAILURE';

export const inviteUser = (email, isAdmin, userType, brokerageId, currentUser) => {
    return {
        type: INVITE_USER,
        value: {
            email,
            isAdmin,
            userType,
            brokerageId,
            currentUser
        }
    };
};

export const inviteUserSuccess = invitation => {
    return {
        type: INVITE_USER_SUCCESS,
        value: invitation
    };
};

export const inviteUserFailure = (error, invitation) => {
    return {
        type: INVITE_USER_FAILURE,
        value: { error, invitation }
    };
};

export const RESEND_INVITATION = 'users/RESEND_INVITATION';
export const RESEND_INVITATION_SUCCESS = 'users/RESEND_INVITATION_SUCCESS';
export const RESEND_INVITATION_FAILURE = 'users/RESEND_INVITATION_FAILURE';

export const resendInvitation = (user, currentUser) => {
    return {
        type: RESEND_INVITATION,
        value: { user, currentUser }
    };
};

export const resendInvitationSuccess = (user, currentUser) => {
    return {
        type: RESEND_INVITATION_SUCCESS,
        value: { user, currentUser }
    };
};

export const resendInvitationFailure = (user, error) => {
    return {
        type: RESEND_INVITATION_FAILURE,
        value: { user, error }
    };
};

export const CLEAR_INVITATION = 'users/CLEAR_INVITATION';

export const clearInvitation = () => {
    return {
        type: CLEAR_INVITATION
    };
};

export const SAVE_USER = 'users/SAVE';
export const SAVE_USER_SUCCESS = 'users/SAVE_USER_SUCCESS';
export const SAVE_USER_FAILURE = 'users/SAVE_USER_FAILURE';

export const saveUser = (user, currentUser) => {
    return {
        type: SAVE_USER,
        value: { user, currentUser }
    };
};

export const saveUserSuccess = user => {
    return {
        type: SAVE_USER_SUCCESS,
        value: { user }
    };
};

export const saveUserFailure = (user, error) => {
    return {
        type: SAVE_USER_FAILURE,
        value: { user, error }
    };
};

export const CHANGE_BROKERAGE = 'users/CHANGE_BROKERAGE';
export const CHANGE_BROKERAGE_SUCCESS = 'users/CHANGE_BROKERAGE_SUCCESS';
export const CHANGE_BROKERAGE_FAILURE = 'users/CHANGE_BROKERAGE_FAILURE';

export const changeBrokerage = (user, newBrokerage, currentUser) => {
    return {
        type: CHANGE_BROKERAGE,
        value: { user, newBrokerage, currentUser }
    };
};

export const changeBrokerageSuccess = user => {
    return {
        type: CHANGE_BROKERAGE_SUCCESS,
        value: { user }
    };
};

export const changeBrokerageFailure = (user, error) => {
    return {
        type: CHANGE_BROKERAGE_FAILURE,
        value: {
            user,
            error
        }
    };
};

export const CLEAR_ERROR = 'users/CLEAR_ERROR';

export const clearError = () => {
    return {
        type: CLEAR_ERROR
    };
};

export const SIGNUP_USER = 'users/SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'users/SIGNUP_USER_SUCCESS';
export const SIGNUP_USER_EXIST = 'users/SIGNUP_USER_EXIST';
export const SIGNUP_USER_FAILED = 'users/SIGNUP_USER_FAILED';
export const SIGNUP_USER_SUCCESS_OPEN_PAGE = 'users/SIGNUP_USER_SUCCESS_OPEN_PAGE';

export const signupUser = email => {
    return {
        type: SIGNUP_USER,
        value: email
    };
};

export const signupUserSuccess = email => {
    return {
        type: SIGNUP_USER_SUCCESS,
        value: email
    };
};

export const signupUserExist = email => {
    return {
        type: SIGNUP_USER_EXIST,
        value: email
    };
};


export const signupUserFailed = (email, error) => {
    return {
        type: SIGNUP_USER_FAILED,
        payload: { email, error }
    };
};


export const signupUserSuccessOpenPage = email => {
    return {
        type: SIGNUP_USER_SUCCESS_OPEN_PAGE,
        value: email
    };
};

export const REQUEST_ACCESS_OPEN_PAGE = 'users/REQUEST_ACCESS_OPEN_PAGE';

export const requestAccessOpenPage = email => {
    return {
        type: REQUEST_ACCESS_OPEN_PAGE,
        value: email
    };
};

export const SEND_REQUEST_ACCESS = 'users/SEND_REQUEST_ACCESS';
export const SEND_REQUEST_ACCESS_SUCCESS = 'users/SEND_REQUEST_ACCESS_SUCCESS';
export const SEND_REQUEST_ACCESS_FAILED = 'users/SIGNUP_USER_FAILED';

export const sendRequestAccess = ({ userData }) => {
    return {
        type: SEND_REQUEST_ACCESS,
        value: userData
    };
};

export const sendRequestAccessSuccess = email => {
    return {
        type: SEND_REQUEST_ACCESS_SUCCESS,
        value: email
    };
};

export const sendRequestAccessFailed = error => {
    return {
        type: SEND_REQUEST_ACCESS_FAILED,
        value: error
    };
};
